import { Pipe } from '@angular/core';
var IsGreaterEqualThanPipe = (function () {
    function IsGreaterEqualThanPipe() {
    }
    IsGreaterEqualThanPipe.prototype.transform = function (input, other) {
        return input >= other;
    };
    return IsGreaterEqualThanPipe;
}());
export { IsGreaterEqualThanPipe };
IsGreaterEqualThanPipe.decorators = [
    { type: Pipe, args: [{ name: 'isGreaterEqualThan' },] },
];
/** @nocollapse */
IsGreaterEqualThanPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-greater-equal-than.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-greater-equal-than.js
// module id = 222
// module chunks = 4